import { render, staticRenderFns } from "./TuiSwitch.vue?vue&type=template&id=08c5f2bc&scoped=true"
import script from "./TuiSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./TuiSwitch.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TuiSwitch.vue?vue&type=style&index=0&id=08c5f2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5f2bc",
  null
  
)

export default component.exports